import { createGlobalStyle } from 'styled-components';
import media from 'styled-query';

import "@fontsource/montserrat" // Defaults to weight 400.
import "@fontsource/dancing-script" // Defaults to weight 400.

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }

  :root {
    --background: #FEFEFE;

    --black: #000000;
    --white: #FFF;
    --gray: #f0f2f5;
    --shadow: #29292E;

    --primary: #bdafeb;
    --secondary: #9e85f1;
    --tertiary: #3a88ff;
    --detail: #a3a3a3;
    --neon: #3df6d9;
    --text: #5d5d63;

    --danger: #E73F5D;
    --success: #04D361;
  }

  html {
    ${media.lessThan('1080px')`
      font-size: 93.75%;
      // default: 16px
      // 16 x 0.9375 = 15px
    `}
    ${media.lessThan('720px')`
      font-size: 87.5%;
    `}
  }

  body {
    background: var(--background);
    color: var(--black);
    -webkit-font-smoothing: antialiased !important;
  }

  body, input, textarea, button, span {
    font: 400 1rem 'Montserrat', sans-serif;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Montserrat', sans-serif;
  }
  .recursive {
    font-family: 'Dancing Script', sans-serif;
    /* font-size: 2rem; */
    font-size: 3vmin;
    text-align: center;
    color: var(--white);
    font-weight: bold;
    align-self: flex-end;
    ${media.lessThan('720px')`
      font-size: 5vmin;
    `}
  }

  button {
    cursor: pointer;
  }

  a {
    text-decoration: none;
    cursor: pointer;
    color: unset;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
    background-color: #F5F5F5;
    border-radius: 10px;
  }

  ::-webkit-scrollbar {
    width: 8px;
    background-color: #F5F5F5;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #FFF;
    background-image: -webkit-gradient(linear,
                      40% 0%,
                      75% 84%,
                      from(var(--primary)),
                      to(var(--primary)),
                      color-stop(.6,var(--tertiary)))
  }
`;